
import { mdiChevronRight } from "@mdi/js"

export default {
    name: "ArticleTeaser",
    emits: ["open"],
    components: { Modal: () => import("@/components/base/modal/Modal") },
    data: () => ({
        mdiChevronRight,
        showArticle: false,
        rowLayout: false,
        rowBreakpoint: 400,
    }),
    methods: {
        onResize() {
            if (this.$refs.articleContainer.offsetWidth < this.rowBreakpoint) {
                if (this.rowLayout) {
                    this.rowLayout = false
                }
            } else {
                if (!this.rowLayout) {
                    this.rowLayout = true
                }
            }
        },
    },
}
